module.exports = __webpack_public_path__ + "img/27.a5850031.jpg";